<template>
  <div class="history">
    <el-dialog
      title="上传准考证历史"
      :visible.sync="dialogVisible"
      width="800px"
      :close-on-click-modal="false"
      class="importfile"
      :before-close="handleCloseDialog"
      :lock-scroll="false"
      top="5vh"
    >
      <table-list
        ref="historyListRef"
        :loading="loading"
        :search-form="searchForm(this)"
        :data="list"
        :columns="columns(this)"
        :operates="operates(this)"
        :pager="pager"
        :options="{ operatesWidth: 100 }"
        @search="onSearch"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></table-list>
    </el-dialog>
  </div>
</template>
<script>
// 搜索框配置
const searchForm = () => [
  {
    label: 'ID',
    prop: 'filter',
  },
]
// 表格列配置
const columns = () => [
  {
    prop: 'id',
    label: '文件ID',
    minWidth: 120,
  },
  {
    prop: 'fileNum',
    label: '拆出证个数',
    minWidth: 80,
  },
  {
    prop: 'uploadUser',
    label: '上传人',
    minWidth: 120,
  },
  {
    prop: 'createTime',
    label: '创建时间',
    minWidth: 160,
  },
]
// 表格操作按钮配置
const operates = _this => [
  {
    method: _this.handleDeleteHistory,
    label: '删除',
  },
]
import TableList from '@/components/TableList'
import to from 'await-to'
import { cardImportHistory, cardHistoryDelete } from '@/api/apply'
export default {
  name: 'History',
  components: {
    TableList,
  },
  data() {
    return {
      dialogVisible: false,
      searchForm,
      columns,
      operates,
      loading: false,
      list: [],
      pager: {
        total: 0,
        size: 20,
        current: 1,
      },
      queryParams: {},
    }
  },
  methods: {
    show() {
      this.dialogVisible = true
      this.getHistoryList()
    },
    async getHistoryList() {
      if (this.loading) return
      const { current, size } = this.pager
      this.loading = true
      const [res, err] = await to(cardImportHistory({ current, size, ...this.queryParams }))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.list = res.data.list
      this.pager.total = res.data.total
    },
    handleCloseDialog() {
      this.list = []
      this.queryParams = {}
      this.$refs.historyListRef.$refs.tableSearchBar.resetSearchForm()
      this.dialogVisible = false
    },
    // 查询按钮
    onSearch(queryParams) {
      this.pager.current = 1
      this.queryParams = queryParams
      this.getHistoryList()
    },
    // 分页
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getHistoryList()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getHistoryList()
    },
    async handleDeleteHistory(row) {
      this.$confirm(`您确定要删除吗？删除后将无法恢复`, '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [, err] = await to(cardHistoryDelete({ id: row.id }))
          if (err) return this.$message.warning(err.msg)
          this.$message.success('删除成功')
          this.getHistoryList()
        })
        .catch(() => {})
    },
  },
}
</script>
